import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { useCompanyPermissions } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { Navigate } from 'react-router';
import { ChangePasswordSection, ChangePinSection } from '@/me/components';

export function SecuritySettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.account')
            },
            { text: t('shared.labels.security') }
        ]);
    }, [setParts, t]);

    const { canViewGeneralSettings } = useCompanyPermissions();
    if (!canViewGeneralSettings) {
        return <Navigate to="/" replace />;
    }

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.security_settings')} />
            <ChangePasswordSection />
            <ChangePinSection />
        </div>
    );
}
